import { mount } from '@/mounter'

import SanitasAccordion from './SanitasAccordion'
import SanitasCollapsible from './SanitasCollapsible'

mount('collapsible', {
  SanitasAccordion,
  SanitasCollapsible,
})
